module.exports = __webpack_public_path__ + "img/firning_silo.78d5eb1e.jpg";